import React from "react";

const ModeToggler = ({ mode }) => {
    if (mode === "light") {
        return  <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="#464646"
        >
            <path d="M12 10.999A4.51 4.51 0 0114.999 14 4.52 4.52 0 0118 11a4.521 4.521 0 01-3.001-3A4.509 4.509 0 0112 10.999zm8.001.001a3.011 3.011 0 012 2.001A3.006 3.006 0 0124 11a3.012 3.012 0 01-2-2 3.01 3.01 0 01-1.999 2zm-1-9a4.514 4.514 0 01-2.998 3.001 4.52 4.52 0 013.001 3.002A4.515 4.515 0 0122 5.001 4.522 4.522 0 0119.001 2zM12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c1.894 0 3.63.497 5.37 1.179C14.422 1.683 8 4.445 8 12c0 7.454 5.917 10.208 9.37 10.821C15.87 23.667 13.894 24 12 24z"></path>
        </svg>
    } else {
        return <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="#bfbfbf"
        >
            <path d="M17 12c0 2.762-2.238 5-5 5s-5-2.238-5-5 2.238-5 5-5 5 2.238 5 5zM7.816 6.401L4.222 2.807 2.808 4.221l3.594 3.595a7.048 7.048 0 011.414-1.415zM12 5c.34 0 .672.033 1 .08V0h-2v5.08c.328-.047.66-.08 1-.08zm5.598 2.815l3.594-3.595-1.414-1.414-3.594 3.595a7.07 7.07 0 011.414 1.414zM5 12c0-.34.033-.672.08-1H0v2h5.08A7.026 7.026 0 015 12zm11.185 5.598l3.594 3.593 1.415-1.414-3.594-3.594a7.08 7.08 0 01-1.415 1.415zm-9.784-1.414l-3.593 3.593 1.414 1.414 3.593-3.593a7.07 7.07 0 01-1.414-1.414zM18.92 11c.047.328.08.66.08 1s-.033.672-.08 1H24v-2h-5.08zM12 19c-.34 0-.672-.033-1-.08V24h2v-5.08c-.328.047-.66.08-1 .08z"></path>
        </svg>
    }
}

export default ModeToggler;